import React, { useRef } from 'react';
export const FileUploader = ({ accept, children, onChange, multiple = false }) => {
    const ref = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: ref, style: { display: 'none' }, type: 'file', onChange: (e) => {
                e.preventDefault();
                const files = e.target.files;
                if (!(files === null || files === void 0 ? void 0 : files.length))
                    return;
                onChange(Array.from(files));
                e.target.value = '';
            }, accept: accept !== null && accept !== void 0 ? accept : "'image/jpeg, image/png'", multiple: multiple }),
        children(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click(); })));
};
//# sourceMappingURL=index.js.map